<div (mouseover)="onLinkHover()" (mouseleave)="onLinkMouseout()">
<a href="javascript:void(0)" (click)="onLinkClick()" >
    {{params.value}}
</a>
<span #favicon [ngClass]="{'noEvent': isGlobalUser, 'hideIcon': isPageKCFilePA}" (click)="onFavClick(params)" >&nbsp;</span>

</div>
